import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getCuratedTemplate, getCuratedTemplatesPage, upsertCuratedTemplate } from './curatedTemplatesApi'
import { extractApiErrorMessage } from '../../helpers/apiErrorMessage'

const curatedTemplatesKey = ['curatedTemplates']
const curatedTemplatesPageKey = (page: number, pageSize: number) => [...curatedTemplatesKey, 'page', page, pageSize]
const curatedTemplateKey = (curatedTemplateId?: string) => [...curatedTemplatesKey, 'detail', curatedTemplateId]

export const useCuratedTemplatesPageQuery = (page: number, pageSize: number) => {
  return useQuery({
    queryKey: curatedTemplatesPageKey(page, pageSize),
    queryFn: () => getCuratedTemplatesPage(page, pageSize),
    keepPreviousData: true,
    onError: () => {
      notification.error({
        message: 'There was a problem loading the curated templates.'
      })
    }
  })
}

export const useCuratedTemplateQuery = (curatedTemplateId?: string) => {
  return useQuery({
    queryKey: curatedTemplateKey(curatedTemplateId),
    queryFn: () => getCuratedTemplate(curatedTemplateId!),
    enabled: !!curatedTemplateId,
    onError: () => {
      notification.error({
        message: 'There was a problem loading the curated template.'
      })
    }
  })
}

export const useUpsertCuratedTemplateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: upsertCuratedTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries(curatedTemplatesKey)
    },
    onError: (error) => {
      notification.error({
        message: 'Could not save the curated template',
        description: extractApiErrorMessage(error, 'Please try again.'),
        style: { whiteSpace: 'pre-line' },
        duration: 0
      })
    }
  })
}
